import request from '@/service'
import areaData from '@/config/areaData'
import { branchIdMap } from '../service/basicData'

/**
 * 查找 city 名字
 */
export function formatCity (city, province) {
  var c = {}
  if (areaData[province]) {
    c = areaData[province].childs.filter(c => c.id === Number(city))[0] || { name: '' }
  } else {
    c = { name: '' }
    for (let i in areaData) {
      if (areaData[i].childs) {
        for (let j in areaData[i].childs) {
          if (areaData[i].childs[j].id === Number(city)) {
            c = areaData[i].childs[j]
            break
          }
        }
      }
    }
  }
  var n = c.name
  if (n[n.length - 1] === '市') n = n.slice(0, n.length - 1)
  return n
}

// 获取所有分会
export function getBranchAll () {
  return new Promise((resolve, reject) => {
    request.getBranchesAll().then((res) => {
      if (Array.isArray(res)) {
        res.forEach(item => {
          item['name'] = formatCity(item.city, item.province)
        })
      }
      resolve(res)
    }).catch(err => { reject(err) })
  })
}

/**
 * 获取指定的分会Id
 * @param {string} name 分会的拼音名，需为 branchIdMap 中 key 值
 */
export function getBranchId (name) {
  const index = process.env.VUE_APP_BUILD_ENV === 'prod' ? 1 : 0
  return branchIdMap[name][index]
}

export function scrollTop (el, from = 0, to, duration = 500, callback) {
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = (
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback) {
        return window.setTimeout(callback, 1000 / 60)
      }
    )
  }
  const difference = Math.abs(from - to)
  const step = Math.ceil(difference / duration * 50)

  function scroll (start, end, step) {
    if (start === end) {
      callback()
      return
    }

    let d = (start + step > end) ? end : start + step
    if (start > end) {
      d = (start - step < end) ? end : start - step
    }

    if (el === window) {
      window.scrollTo(d, d)
    } else {
      el.scrollTop = d
    }
    window.requestAnimationFrame(() => scroll(d, end, step))
  }
  scroll(from, to, step)
}
